// TODO: `24시간 채널명 리스트`를 keywords에 추가
const liveListTagData = { shareTitle: 'SBS 라이브 : 채널 리스트', shareDescription: 'SBS, SBS라디오, SBS PLUS, SBS Biz 등 다양한 SBS 라이브 채널 리스트와 레전드 프로그램들의 24시간 TV 채널 리스트', shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/sbs_live.png', currentUrl: 'https://www.sbs.co.kr/live', keywords: 'SBS,실시간 방송 무료보기,sbs 온에어,sbs 온에어 무료보기,실시간tv 무료,실시간sbs방송,sbs 실시간 tv보기,sbstv보기실시간방송,sbs온에어tv실시간 무료보기,무료 실시간 tv보기,SBS 드라마 무료보기,SBS tv무료보기,실시간 티비 sbs,무료 실시간 티비(tv)보기,SBS 라디오,SBS 파워FM,SBS 러브FM' };
// TODO: `방송 중인 프로그램명`을 TITLE에 추가
const liveEndTagData = { shareTitle: 'SBS 라이브 : ', shareDescription: 'SBS 실시간 라이브 방송을 24시간 끊김없이 무료로 즐기세요', shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/sbs_live.png', currentUrl: 'https://www.sbs.co.kr/live/', keywords: 'SBS,실시간 방송 무료보기,sbs 온에어,sbs 온에어 무료보기,실시간tv 무료,실시간sbs방송,sbs 실시간 tv보기,sbstv보기실시간방송,sbs온에어tv실시간 무료보기,무료 실시간 tv보기,SBS 드라마 무료보기,SBS tv무료보기,실시간 티비 sbs,무료 실시간 티비(tv)보기' };

export default function index (channelId = '') {
  let result = { ...liveListTagData };

  if (channelId) {
    result = { ...liveEndTagData };
    result.currentUrl += channelId;
  }

  return result;
}
